import { ChainType } from "@0xsquid/squid-types";
import { UseMutationResult } from "@tanstack/react-query";
import React, { createContext, useContext } from "react";
import { useBitcoin } from "../../hooks/bitcoin/useBitcoin";
import { BitcoinConnector } from "../types/bitcoin";
import { BitcoinWallet, ConnectWalletResult } from "../types/wallet";

export interface IBitcoinContextData {
  connectBitcoin: UseMutationResult<
    ConnectWalletResult<ChainType.BTC>,
    unknown,
    {
      wallet: BitcoinWallet;
    },
    unknown
  >;
  signer: BitcoinConnector | undefined;
}

export const BitcoinContext = createContext<IBitcoinContextData | undefined>(
  undefined
);

export const BitcoinProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const bitcoinContext = useBitcoin();

  return (
    <BitcoinContext.Provider value={bitcoinContext}>
      {children}
    </BitcoinContext.Provider>
  );
};

export const useBitcoinContext = (): IBitcoinContextData => {
  const context = useContext(BitcoinContext);
  if (!context) {
    throw new Error("useBitcoinContext must be used within a BitcoinProvider");
  }
  return context;
};
